import startCase from "lodash/startCase";

export const SYNTAX_DELIMITER = "****";

export const splitCodeBlocks = (text: string): Array<string> => {
    const [inputBlock, ...outputBlocks] = text.split(SYNTAX_DELIMITER);
    const outputBlock = outputBlocks.join("");

    return [inputBlock, outputBlock];
};

// Language names that aren't correctly formatted by startCase
const FORMATTED_LANGUAGES = [
    "SQL",
    "YAML",
    "C",
    "C#",
    "C++",
    "JSON",
    "TOML",
    "PHP",
    "XML",
    "JDBC",
    "ODBC",
    "MongoDB",
    "WIT",
    "VS Code",
    "VSCode",
    "CSV",
    "TSV",
    "JavaScript",
    "HTTP Header",
];

type LanguageMappingType = {
    bash: string;
};

// bash should be mapped to shell for display purposes
const LANGUAGE_MAPPING: LanguageMappingType = {
    bash: "shell",
};

// Takes a language, from paligo's attributes, and formats it correctly
export const formatLanguage = (language: string): string => {
    let displayLanguage = language.toLowerCase();
    if (displayLanguage in LANGUAGE_MAPPING) {
        displayLanguage =
            LANGUAGE_MAPPING[displayLanguage as keyof LanguageMappingType];
    }

    for (const formattedLanguage of FORMATTED_LANGUAGES) {
        if (displayLanguage === formattedLanguage.toLowerCase()) {
            return formattedLanguage;
        }
    }

    return startCase(displayLanguage);
};
